<ng-container *ngIf="facade.mobileNavigationLinksDetails$ | async as content">
  <idp-mobile-nav-links
    [content]="content"
    [isMenuOpen]="isMenuOpen"
    [selectedNav]="selectedNav"
    [isMobileDevice]="isMobile"
    [isAlertAdvisory]="isAlertAdvisory"
    [isBusiness]="isBusiness"
    [collapsedHeader]="collapsedHeader"
    [viewSearchOptionExpanded]="viewSearchOptionExpanded"
    (primaryNavAction)="
      onWidgetNavActionEvent($event); mobileWidgetNavClick.emit(true)
    "
    (analyticsEvent)="emitAdobeAnalytics($event)"
  ></idp-mobile-nav-links>
</ng-container>
